import {
    FaChild,
    FaCity,
    FaVenusMars,
    FaSchool,
    FaUser
} from 'react-icons/fa';
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ServicesWrapper from '../Common/Services/page';
import { QUERY_KEYS_SIH } from '../../Common/hooks/useChartsData';
import { subtitlesMap } from '../Common/maps/subtitleMap';
import { Table } from './AgeGroup/Table';
import { CityServicesWrapper } from './CityServices';
import ChartsContainer from '../../Common/ChartsContainer';

const menus = [
    {
        title: 'Faixa Etária',
        path: '/governanceroom/dashboardsihsus/perfil/agegroup',
        icon: <FaChild />
    },
    {
        title: 'Gênero',
        path: '/governanceroom/dashboardsihsus/perfil/gender',
        icon: <FaVenusMars />
    },
    {
        title: 'Raça/Cor',
        path: '/governanceroom/dashboardsihsus/perfil/ethnicity',
        icon: <FaUser />
    },
    {
        title: 'Escolaridade',
        path: '/governanceroom/dashboardsihsus/perfil/education',
        icon: <FaSchool />
    },
    {
        title: 'Município',
        path: '/governanceroom/dashboardsihsus/perfil/city',
        icon: <FaCity />
    }
];

const titleMap = {
    '/governanceroom/dashboardsihsus/perfil/agegroup':
        'Atendimentos - Faixa Etária',
    '/governanceroom/dashboardsihsus/perfil/gender': 'Atendimentos - Gênero',
    '/governanceroom/dashboardsihsus/perfil/ethnicity':
        'Atendimentos - Raça/Cor',
    '/governanceroom/dashboardsihsus/perfil/education':
        'Atendimentos - Escolaridade',
    '/governanceroom/dashboardsihsus/perfil/city': 'Atendimentos - Município'
};

export const Perfil = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardsihsus');
    };

    return (
        <div className="producao-container">
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <div>
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="ethnicity"
                            element={
                                <ServicesWrapper
                                    module={{
                                        sectionTitle: 'das AIH por Raça/Cor'
                                    }}
                                    queryConfig={{
                                        key: QUERY_KEYS_SIH.ETHNICITY_PERFIL,
                                        url: 'governanceroom/dashboard/sihsus/aih/ethnicity'
                                    }}
                                    subtitlesMap={subtitlesMap}
                                />
                            }
                        />

                        <Route
                            path="gender"
                            element={
                                <ServicesWrapper
                                    module={{
                                        sectionTitle: 'das AIH por Sexo'
                                    }}
                                    queryConfig={{
                                        key: QUERY_KEYS_SIH.GENDER_PERFIL,
                                        url: 'governanceroom/dashboard/sihsus/aih/gender'
                                    }}
                                    subtitlesMap={subtitlesMap}
                                />
                            }
                        />
                        <Route
                            path="agegroup"
                            element={
                                <ServicesWrapper
                                    module={{
                                        sectionTitle: 'das AIH por Idade'
                                    }}
                                    queryConfig={{
                                        key: QUERY_KEYS_SIH.AGE_GROUP_PERFIL,
                                        url: 'governanceroom/dashboard/sihsus/aih/age'
                                    }}
                                    subtitlesMap={subtitlesMap}
                                >
                                    <Table />
                                </ServicesWrapper>
                            }
                        />

                        <Route
                            path="education"
                            element={
                                <ServicesWrapper
                                    module={{
                                        title: 'Atendimentos - Escolaridade',
                                        sectionTitle: 'das AIH por Escolaridade'
                                    }}
                                    queryConfig={{
                                        key: QUERY_KEYS_SIH.EDUCATION_PERFIL,
                                        url: 'governanceroom/dashboard/sihsus/aih/education'
                                    }}
                                    subtitlesMap={subtitlesMap}
                                />
                            }
                        />

                        <Route
                            path="city"
                            element={
                                <CityServicesWrapper
                                    queryConfig={{
                                        key: QUERY_KEYS_SIH.CITY_PERFIL,
                                        url: 'governanceroom/dashboard/sihsus/aih/city',
                                        allCityUnits: true
                                    }}
                                />
                            }
                        />

                        <Route
                            path="/"
                            element={<Navigate to="agegroup" replace />}
                        />
                    </Routes>
                </ChartsContainer>
            </div>
        </div>
    );
};
